import { useTranslation } from "react-i18next"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import { UserCreatorProps } from "./types"
import { useStyles } from "./styles"
import { Box, Grid, Typography } from "@mui/material"
import { NewListTooltipDetail } from "../../../../../../components/newListTooltipDetail"
import { KeyCaption } from "../../../../../../components/detailKeyValue/keyCaption.index"
import { icons } from "../../../../../../utils/icons"



export const UserCreator = ({ area, department, name, role, userType }: UserCreatorProps) => {


    const { t } = useTranslation()
    const styles = useStyles()

    return (

        <Box sx={styles.flex1}>
            <Typography variant="title_grey" fontSize={16}>{t('filesManager.titles.userCreator')}</Typography>

            <CustomPaper elevation={3} sx={styles.container}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={3} sx={styles.grid}>
                        {icons('personFilled')}

                        <Typography variant="title_grey" fontSize={16}>{name}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={2} xl={2} sx={styles.gridSecond}>
                        <KeyCaption caption={t('filesManager.tags.role')} value={role} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={2} xl={2} sx={styles.gridSecond}>
                        <KeyCaption caption={t('filesManager.tags.area')} value={<NewListTooltipDetail list={area || []} isBold />} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={2} xl={2} sx={styles.gridSecond}>
                        <KeyCaption caption={t('filesManager.tags.department')} value={<NewListTooltipDetail list={department || []} isBold />} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={2} xl={2} sx={styles.gridSecond}>
                        <KeyCaption caption={t('filesManager.tags.userType')} value={userType} />
                    </Grid>
                </Grid>
            </CustomPaper>
        </Box>
    )
}